 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"6a47b5c","1":"d7485ce","2":"dfd9c6f","3":"1cc0173","4":"59eaeb9","5":"c2adecc","6":"0273ad5","7":"387b86e","8":"a571a7a","9":"5291b4a","10":"520aeb4","11":"6faeb0c","12":"023313c","13":"cd72123","14":"1cccd89","15":"8ed974e","16":"215db52","17":"ccd9d46","18":"015f66f","19":"fbfdaa4","20":"5a161cb","21":"6894bc5","22":"267b3b1","23":"12c35bd","24":"88b53a3","25":"2663904","26":"11bd147","27":"d2c5c74","28":"ebc0e23","29":"c2b2c62","30":"f3794c0","31":"0396556","32":"703b6ea","33":"fa43b89","34":"77421a5","35":"b638db4","36":"a6419fb","37":"a3c143b","38":"46cc69f","39":"eb92f01","40":"91c7409","41":"4ee6ee9","42":"b913fbe","43":"2ad8e8b","44":"4f18637","45":"5ed3fe2","46":"72aab29","47":"2350dad","48":"4c5d6c4","49":"0e0e729","50":"ffd9d06","51":"aa5de3a","52":"13691a6","53":"e982b45","54":"cbf6790","55":"2be98b9","56":"753e904","57":"28a41ce","58":"a39f029","59":"1a5f91a","60":"2e06dd9","61":"69d20fc","62":"c09408f","63":"b60c03f","64":"a8b9aa0","65":"b3905db","66":"3f28dac","67":"85e702d","68":"c30527f","69":"48ec15d","70":"862b5a4","71":"82433ee","72":"b4e5528","73":"ab239b5","74":"6bf988a","75":"7f76a11","76":"2f26a49","77":"9aa30ac","78":"2fea1a9","79":"602dd90","80":"f29be69","81":"f216341","82":"b8b108c","83":"a895ebe","84":"c0ebbc4","85":"167f6d5","86":"26e487a","87":"0f9eee3","88":"290edc3","89":"222712a","90":"26f3a86","91":"fb80037","92":"af57df7","93":"b14a03a","94":"9c98e8e","95":"1acc094","96":"f4b5d3a","97":"ba44404","98":"fe76ee4","99":"46b4fee","100":"a8833a7","101":"2547d05","102":"f8d1c68","103":"b40958f","104":"3153fd7","105":"9d65f97","106":"82345af","107":"72c98c2","108":"9ab8bae","109":"3ad8a39","110":"740a42a","111":"bb01879","112":"f18cd1a","113":"5ffbdca","114":"e49230c","115":"d5c769a","116":"ff2587c","components/hot-iframe-sso":"a61b3bb","vendors/pages/index":"7926aec","components/hot-app-store-button":"39b8125","pages/index":"654f45d","components/delay-hydration":"c9bf4ca","components/hot-accordion":"2ffabed","components/hot-accordion-item":"2be86c3","components/hot-organic-accordion":"f808dc6","components/hot-organic-accordion-item":"59a28e5","components/hot-organic-accordion-item-custom":"f393ed9","components/hot-organic-button":"7db1d0d","components/hot-tag":"dd39da9","components/hot-video":"8645bc5","components/hydration-status":"4a46501","lang-es-co.js":"569bfcb","lang-es-es.js":"1da0444","lang-es-mx.js":"ca26c61","lang-es.js":"029c9e9","lang-fr.js":"8507057","lang-it.js":"389e4d7","lang-jp.js":"94b2667","lang-pt-br.js":"917998a","pages/404":"118fc1f","pages/about":"1f40b4e","pages/affiliates":"22dacfb","pages/club":"673e167","pages/hotmart-app":"4888e7d","pages/is-hotmart-for-me":"6eb0699","pages/lp-producer":"ef1505b","pages/members-area/index/pages/members-area/paid-media":"910b9ca","pages/members-area/index":"ec032e5","pages/members-area/paid-media":"a2532bc","pages/members-area/thank-you":"9b3af07","pages/payments":"7f77a09","pages/pricing":"52dc908","pages/producers":"3801cbe","pages/sitemap":"9413a47","pages/solutions":"41d7bba","pages/tour/_id":"d748bbe","pages/tour/index":"9b5dd27"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// extract-css-chunks-webpack-plugin CSS loading
 		var supportsPreload = (function() { try { return document.createElement("link").relList.supports("preload"); } catch(e) { return false; }}());
 		var linkExists = false
 		var cssChunks = {"0":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"62":1,"63":1,"64":1,"65":1,"66":1,"67":1,"68":1,"69":1,"70":1,"71":1,"72":1,"73":1,"74":1,"75":1,"76":1,"77":1,"78":1,"79":1,"80":1,"81":1,"82":1,"83":1,"84":1,"85":1,"86":1,"87":1,"88":1,"89":1,"90":1,"91":1,"92":1,"93":1,"94":1,"95":1,"96":1,"97":1,"98":1,"99":1,"100":1,"101":1,"102":1,"103":1,"104":1,"105":1,"106":1,"107":1,"108":1,"109":1,"110":1,"111":1,"112":1,"113":1,"114":1,"components/hot-iframe-sso":1,"components/hot-app-store-button":1,"pages/index":1,"components/hot-accordion":1,"components/hot-accordion-item":1,"components/hot-organic-accordion":1,"components/hot-organic-accordion-item":1,"components/hot-organic-accordion-item-custom":1,"components/hot-organic-button":1,"components/hot-tag":1,"components/hot-video":1,"pages/affiliates":1,"pages/club":1,"pages/hotmart-app":1,"pages/lp-producer":1,"pages/members-area/index/pages/members-area/paid-media":1,"pages/members-area/index":1,"pages/members-area/thank-you":1,"pages/pricing":1,"pages/solutions":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + {"0":"bc92dc3","1":"31d6cfe","2":"ac54777","3":"cbabb86","4":"cdcdb3d","5":"66645f7","6":"08c6c3b","7":"351380d","8":"19989c6","9":"4007b79","10":"c8112fa","11":"54a8347","12":"ed7a8c4","13":"75e67e8","14":"c042bc4","15":"39c5a44","16":"31d6cfe","17":"31d6cfe","18":"be41761","19":"02946a2","20":"be814ea","21":"c32563d","22":"241ffb1","23":"e863632","24":"4188e7c","25":"5600e18","26":"0f3ddc3","27":"d70f182","28":"e2c2f75","29":"fdade79","30":"a04a862","31":"d75264e","32":"93aff2e","33":"ad26373","34":"80e4f98","35":"a020706","36":"eb8103c","37":"4468057","38":"08fe6d2","39":"064c4b1","40":"09c7f16","41":"ac4ef9f","42":"f75b75e","43":"689759f","44":"e48ac1d","45":"f3e0ea2","46":"99d4bdc","47":"00f530c","48":"ab0e1fc","49":"26aad64","50":"56e0dd1","51":"727ff82","52":"fef25de","53":"5c5ce5e","54":"6e1d829","55":"f435948","56":"de69fb0","57":"dd2d0c8","58":"4a8c44c","59":"34f525f","60":"30aa5b5","61":"72bfb9d","62":"b5d48e2","63":"f759bb7","64":"56abd46","65":"5535ef7","66":"df1bd4f","67":"c1e4f65","68":"3f9d89d","69":"3f53998","70":"047da8f","71":"61d5c1c","72":"8e580b9","73":"ab64f81","74":"66645f7","75":"77a873c","76":"e4f3dcf","77":"f52ea8e","78":"b54ff1c","79":"5670dd5","80":"a5c4bdf","81":"848597c","82":"a2a2e07","83":"5a61a94","84":"8945d3a","85":"96b37b0","86":"972a3e4","87":"01bb85e","88":"9b60878","89":"85f5fcb","90":"b82956b","91":"77dcec5","92":"9e3df9d","93":"885540e","94":"45deec5","95":"76d7586","96":"ae59dbb","97":"bedc643","98":"fe5f52e","99":"df95389","100":"0a0f1f7","101":"80e10ea","102":"0681781","103":"f0d8317","104":"443998a","105":"573a98f","106":"d8beaf2","107":"6223a7e","108":"9a60522","109":"c881277","110":"1d007c1","111":"f68e80c","112":"da26f13","113":"e22d49c","114":"11a0668","115":"31d6cfe","116":"31d6cfe","components/hot-iframe-sso":"d66ab2d","vendors/pages/index":"31d6cfe","components/hot-app-store-button":"935e4c5","pages/index":"1455007","components/delay-hydration":"31d6cfe","components/hot-accordion":"ab64f81","components/hot-accordion-item":"5a2d087","components/hot-organic-accordion":"bd7f697","components/hot-organic-accordion-item":"1c5ba8d","components/hot-organic-accordion-item-custom":"c0c5be2","components/hot-organic-button":"c730dbd","components/hot-tag":"d70ca71","components/hot-video":"00c5276","components/hydration-status":"31d6cfe","lang-es-co.js":"31d6cfe","lang-es-es.js":"31d6cfe","lang-es-mx.js":"31d6cfe","lang-es.js":"31d6cfe","lang-fr.js":"31d6cfe","lang-it.js":"31d6cfe","lang-jp.js":"31d6cfe","lang-pt-br.js":"31d6cfe","pages/404":"31d6cfe","pages/about":"31d6cfe","pages/affiliates":"97f7dff","pages/club":"de22bd5","pages/hotmart-app":"8cca359","pages/is-hotmart-for-me":"31d6cfe","pages/lp-producer":"5691784","pages/members-area/index/pages/members-area/paid-media":"a222544","pages/members-area/index":"de22bd5","pages/members-area/paid-media":"31d6cfe","pages/members-area/thank-you":"e945570","pages/payments":"31d6cfe","pages/pricing":"be079d9","pages/producers":"31d6cfe","pages/sitemap":"31d6cfe","pages/solutions":"236939f","pages/tour/_id":"31d6cfe","pages/tour/index":"31d6cfe"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if((tag.rel === "stylesheet" || tag.rel === "preload") && (dataHref === href || dataHref === fullhref)) {
 						linkExists = true
 						return resolve();
 					}
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = supportsPreload ? "preload": "stylesheet";
 				supportsPreload ? linkTag.as = "style" : linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0]; head.appendChild(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 				if(!linkExists && supportsPreload) {
 					var execLinkTag = document.createElement("link");
 					execLinkTag.href =  __webpack_require__.p + "css/" + {"0":"bc92dc3","1":"31d6cfe","2":"ac54777","3":"cbabb86","4":"cdcdb3d","5":"66645f7","6":"08c6c3b","7":"351380d","8":"19989c6","9":"4007b79","10":"c8112fa","11":"54a8347","12":"ed7a8c4","13":"75e67e8","14":"c042bc4","15":"39c5a44","16":"31d6cfe","17":"31d6cfe","18":"be41761","19":"02946a2","20":"be814ea","21":"c32563d","22":"241ffb1","23":"e863632","24":"4188e7c","25":"5600e18","26":"0f3ddc3","27":"d70f182","28":"e2c2f75","29":"fdade79","30":"a04a862","31":"d75264e","32":"93aff2e","33":"ad26373","34":"80e4f98","35":"a020706","36":"eb8103c","37":"4468057","38":"08fe6d2","39":"064c4b1","40":"09c7f16","41":"ac4ef9f","42":"f75b75e","43":"689759f","44":"e48ac1d","45":"f3e0ea2","46":"99d4bdc","47":"00f530c","48":"ab0e1fc","49":"26aad64","50":"56e0dd1","51":"727ff82","52":"fef25de","53":"5c5ce5e","54":"6e1d829","55":"f435948","56":"de69fb0","57":"dd2d0c8","58":"4a8c44c","59":"34f525f","60":"30aa5b5","61":"72bfb9d","62":"b5d48e2","63":"f759bb7","64":"56abd46","65":"5535ef7","66":"df1bd4f","67":"c1e4f65","68":"3f9d89d","69":"3f53998","70":"047da8f","71":"61d5c1c","72":"8e580b9","73":"ab64f81","74":"66645f7","75":"77a873c","76":"e4f3dcf","77":"f52ea8e","78":"b54ff1c","79":"5670dd5","80":"a5c4bdf","81":"848597c","82":"a2a2e07","83":"5a61a94","84":"8945d3a","85":"96b37b0","86":"972a3e4","87":"01bb85e","88":"9b60878","89":"85f5fcb","90":"b82956b","91":"77dcec5","92":"9e3df9d","93":"885540e","94":"45deec5","95":"76d7586","96":"ae59dbb","97":"bedc643","98":"fe5f52e","99":"df95389","100":"0a0f1f7","101":"80e10ea","102":"0681781","103":"f0d8317","104":"443998a","105":"573a98f","106":"d8beaf2","107":"6223a7e","108":"9a60522","109":"c881277","110":"1d007c1","111":"f68e80c","112":"da26f13","113":"e22d49c","114":"11a0668","115":"31d6cfe","116":"31d6cfe","components/hot-iframe-sso":"d66ab2d","vendors/pages/index":"31d6cfe","components/hot-app-store-button":"935e4c5","pages/index":"1455007","components/delay-hydration":"31d6cfe","components/hot-accordion":"ab64f81","components/hot-accordion-item":"5a2d087","components/hot-organic-accordion":"bd7f697","components/hot-organic-accordion-item":"1c5ba8d","components/hot-organic-accordion-item-custom":"c0c5be2","components/hot-organic-button":"c730dbd","components/hot-tag":"d70ca71","components/hot-video":"00c5276","components/hydration-status":"31d6cfe","lang-es-co.js":"31d6cfe","lang-es-es.js":"31d6cfe","lang-es-mx.js":"31d6cfe","lang-es.js":"31d6cfe","lang-fr.js":"31d6cfe","lang-it.js":"31d6cfe","lang-jp.js":"31d6cfe","lang-pt-br.js":"31d6cfe","pages/404":"31d6cfe","pages/about":"31d6cfe","pages/affiliates":"97f7dff","pages/club":"de22bd5","pages/hotmart-app":"8cca359","pages/is-hotmart-for-me":"31d6cfe","pages/lp-producer":"5691784","pages/members-area/index/pages/members-area/paid-media":"a222544","pages/members-area/index":"de22bd5","pages/members-area/paid-media":"31d6cfe","pages/members-area/thank-you":"e945570","pages/payments":"31d6cfe","pages/pricing":"be079d9","pages/producers":"31d6cfe","pages/sitemap":"31d6cfe","pages/solutions":"236939f","pages/tour/_id":"31d6cfe","pages/tour/index":"31d6cfe"}[chunkId] + ".css";
 					execLinkTag.rel = "stylesheet";
 					execLinkTag.type = "text/css";
 					document.body.appendChild(execLinkTag);
 				}
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/app-hotmart/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
